import { gql } from '@apollo/client'
export const BLOGPOSTS = (limit = 1000) => {
  return gql`
  query blogPostQuery {
    posts(first: ${limit}) {
      nodes {
        title
        slug
        date
        content
        excerpt
        featuredImage {
          node {
            sourceUrl
          }
        }
        categories {
          nodes {
            name
          }
        }
        author {
          node {
            avatar {
              url
            }
            id
            firstName
            lastName
            name
            username
          }
        }
      }
    }
  }
`
}

// get slugs for the static paths

export const BLOG_POST_SLUG = gql`
  {
    posts(first: 10000) {
      nodes {
        slug
      }
    }
  }
`

export const SINGLE_POST_BY_SLUG = gql`
  query blogPostQuery($id: ID!, $idType: PostIdType!) {
    post(id: $id, idType: $idType) {
      title
      slug
      date
      content
      featuredImage {
        node {
          sourceUrl
        }
      }
    }
  }
`
export const EVENTSPOSTTYPE = gql`
  query eventsPostsQuery {
    events(first: 1000) {
      nodes {
        id
        title
        slug
        date
        featuredImage {
          node {
            sourceUrl
          }
        }
        excerpt
        content
        eventsPostTypes {
          eventDate
          eventCity
          eventCountry
          eventUrl
        }
      }
    }
  }
`
export const MEDIAPOST = gql`
  query mediaPostsQuery {
    mediaPosts(first: 1000) {
      nodes {
        title
        slug
        featuredImage {
          node {
            sourceUrl
          }
        }

        mediaPostType {
          videoUrl
        }
        categories {
          nodes {
            id
            name
          }
        }
      }
    }
  }
`
